
import Vue from "vue";


export default Vue.extend({
  data() {
    return {
      userData: null,
      activeIndex: '/conference-management',
      dateKey: Math.random(),
      isDisable: false,
      otherRemind: 0,
      approveNumSum: 0
    };
  },

  methods: {
    activeAside(router: string) {
      return this.$route.fullPath === router;
    },
    logout() {
      window.close();
      window.opener = null;
    },
    handleSelect(router: string, keyPath: string) {
      sessionStorage.setItem('keyPath', keyPath);
      this.dateKey = Math.random()
    },
  },
});
